import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarDetailsRevamp from "./component";
import { fetchCarDetails, updateCarDetailsSSRStatus, setGsGalleryData, fetchSimilarCars, updateLoginFetchCarDetailCompleted, setCurrentDeliveryTimeline, fetchCmsConfig, setCarSeenCount, fetchLeadAppointment, reloadCarDetails } from "./actions";
import { withRouter } from "react-router-dom";
import { reloadCarList } from "../car-listing/actions";
import { clearAllFilters, updateSelectedSuggestions, updateFilterOptionData } from "../filters/actions";
import withLogin from "../with-login";
import withWishlist from "../with-wishlist";
import { getDeliveryInfo } from "../delivery-info/actions";
import { createOrder, fetchEgcPrice, getOrderDetail, updateOrder, getCheckoutSteps, getWarrantyPlans, getIsStraightThroughEligble, updateValidC2bOrder, getTradeInDetails, createClassifiedLead, updateBasicHubspot } from "../checkout-info/actions";
import { fetchConfig } from "../home/actions";
import { getInhouseEligibility, getInhousePreApprovalLoanDetails, getInterestRateForPriceCalculator, setPreApprovalCoachMarkDisplay } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { getTradeInToggleVisible } from "../trade-in-your-car-wrapper/actions";
import { getGuestToken, setLoginType } from "../../au.configuration/actions";
import { setNudgeTimerId, updateNotificationCounts, updateNudgeCounts, updateSupportWidgetConfig } from "../support-widget/actions";
import { getDealerInfo } from "../dealer-page-components/actions";

const mapStateToProps = ({
    carDetails,
    location: {
        selectedCity
    },
    deliveryInfo: {
        appliedDeliveryPincode
    },
    user: {
        secureToken,
        hideSiteHeader,
        userGeoData,
        gaId,
        phoneNumberVerified,
        isLoggedIn,
        email,
        mobile,
        isUserZeroDpVariant,
        fullName = ""
    },
    checkout: {
        order: { status: orderStatus, splitPaymentOpted, orderId, financeProvider, testDriveStatus, deliveryAddress },
        personalDetails: {
            firstName = "",
            lastName = "",
            userEmail = ""
        }
    },
    filters: {
        allFilters,
        appliedFilters,
        selectedSort,
        listingType
    },
    abExperiment: {
        showFullScreenGallery,
        showInHouseFinance,
        showPremiumFeatures,
        showUserDeliveryTimeline,
        showCdpGalleryVariant,
        cdpBiCta,
        desktopCdpEw,
        desktopPremiumFeatures,
        desktopWishlistAdoption,
        webCarTour,
        cdpCtaReorder,
        desktopLuxuryCars,
        hideImperfectionsDesktop,
        desktopVehicleBasePrice,
        desktopComingSoon
    },
    config: {
        saleConfig,
        testDriveConfig
    },
    preApprovalLoan: {
        inHouseFinanceEligibility,
        showPreApprovalCoachmark
    },
    tradeIn: {
        tradeInToggleSelected
    },
    supportWidget: {
        showEmailSupportModal,
        categoryNudgeCounts,
        nudgeCountSynced
    },
    myBookings: {
        paymentSummaryData
    },
    dealer: {
        dealerInfo,
        isSSR: dealerSSR
    },
    cmsConfig: rootCmsConfig
}) => ({
    email,
    mobile,
    carDetails,
    selectedCity,
    appliedDeliveryPincode,
    secureToken,
    orderStatus,
    splitPaymentOpted,
    isLoggedIn,
    showFullScreenGallery,
    saleConfig,
    orderId,
    showInHouseFinance,
    inHouseFinanceEligibility,
    tradeInToggleSelected,
    showPreApprovalCoachmark,
    showPremiumFeatures,
    showUserDeliveryTimeline,
    financeProvider,
    allFilters,
    appliedFilters,
    selectedSort,
    listingType,
    isUserZeroDpVariant,
    showCdpGalleryVariant,
    hideSiteHeader,
    cdpBiCta,
    testDriveStatus,
    userGeoData,
    // showTestDriveLocation
    gaId,
    showEmailSupportModal,
    testDriveConfig,
    desktopWishlistAdoption,
    categoryNudgeCounts,
    nudgeCountSynced,
    desktopCdpEw,
    desktopPremiumFeatures,
    paymentSummaryData,
    fullName,
    firstName,
    lastName,
    userEmail,
    webCarTour,
    phoneNumberVerified,
    orderCustomerPhoneNumber: deliveryAddress?.customerPhoneNumber,
    cdpCtaReorder,
    dealerInfo,
    dealerSSR,
    desktopLuxuryCars,
    hideImperfectionsDesktop,
    desktopVehicleBasePrice,
    desktopComingSoon,
    rootCmsConfig
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchCarDetailsConnect: fetchCarDetails,
            updateCarDetailsSSRStatusConnect: updateCarDetailsSSRStatus,
            setGsGalleryDataConnect: setGsGalleryData,
            reloadCarListConnect: reloadCarList,
            clearAllFiltersConnect: clearAllFilters,
            fetchSimilarCarsConnect: fetchSimilarCars,
            getDeliveryInfoConnect: getDeliveryInfo,
            getOrderDetailConnect: getOrderDetail,
            fetchConfigConnect: fetchConfig,
            updateLoginFetchCarDetailCompletedConnect: updateLoginFetchCarDetailCompleted,
            fetchEgcPriceConnect: fetchEgcPrice,
            createOrderConnect: createOrder,
            updateBasicHubspotConnect: updateBasicHubspot,
            updateOrderConnect: updateOrder,
            getCheckoutStepsConnect: getCheckoutSteps,
            getInhouseEligibilityConnect: getInhouseEligibility,
            getTradeInToggleVisibleConnect: getTradeInToggleVisible,
            getWarrantyPlansConnect: getWarrantyPlans,
            setPreApprovalCoachMarkDisplayConnect: setPreApprovalCoachMarkDisplay,
            setDeliveryTimelineConnect: setCurrentDeliveryTimeline,
            getGustTokenInfoConnect: getGuestToken,
            updateSelectedSuggestionsConnect: updateSelectedSuggestions,
            updateFilterOptionDataConnect: updateFilterOptionData,
            setLoginTypeConnect: setLoginType,
            getInhousePreApprovalLoanDetailsConnect: getInhousePreApprovalLoanDetails,
            getIsStraightThroughEligbleConnect: getIsStraightThroughEligble,
            getInterestRateForPriceCalculatorConnect: getInterestRateForPriceCalculator,
            updateValidC2bOrderConnect: updateValidC2bOrder,
            getTradeInDetailsConnect: getTradeInDetails,
            fetchCmsConfigConnect: fetchCmsConfig,
            updateSupportWidgetConfigConnect: updateSupportWidgetConfig,
            updateNudgeCountsConnect: updateNudgeCounts,
            updateNotificationCountsConnect: updateNotificationCounts,
            setNudgeTimerIdConnect: setNudgeTimerId,
            setCarSeenCountConnect: setCarSeenCount,
            fetchLeadAppointmentConnect: fetchLeadAppointment,
            createClassifiedLeadConnect: createClassifiedLead,
            getDealerInfoConnect: getDealerInfo,
            reloadCarDetailsConnect: reloadCarDetails
        },
        dispatch
    );

export default withLogin(withWishlist(withRouter(connect(mapStateToProps, mapDispatchToProps)(CarDetailsRevamp))));
